module.exports = __webpack_public_path__ + "static/usecase_consignment_right_bg@2x-61620b2c541cbe417baf9a81296db689.png";